export default __webpack_public_path__ + "static/media/updates-popup.b6cd0fcd.png";